<template>
  <span class="reference-select-wrapper" v-if="!isReadOnly">
    <Reference :attribute="attribute" :placeholder="compPlaceholder" :filter="filter"/>
  </span>
  <span v-else-if="attribute.label.value">{{attribute.label.value}}</span>
  <span v-else>&ZeroWidthSpace;{{ nullDisplayValue }}</span> <!-- wenn attribute ungesetzt ist stelle Whitespace dar, damit regulärere Platz reserviert wird-->
</template>

<script lang="ts">

import ReferenceXMLRDB from "../../xmlrdb-data/Reference"
import Reference from "../base/Reference.vue"
import { computed, watchEffect } from "vue"
export default {
	
  name: "referenceField",
  props: {
    attribute: ReferenceXMLRDB,
    isReadOnly: Boolean,
    filter: Function,
    placeholder: { type: String, default: "Bitte auswählen" },
    nullDisplayValue: { type: String, default: "" },
  },
  components: {
    Reference
  },
  setup(props){
    
    let compPlaceholder = computed(() => {
      if (props.attribute.metadata.tagByName("UnsetLookupLabel")) {
        return  props.attribute.metadata.tagByName("UnsetLookupLabel").value();
      }
      return props.placeholder;
    })
    
    return {
      compPlaceholder
    }
  }
}

</script>

<style scoped>

</style>